import { render } from "./TasksPage.vue?vue&type=template&id=9b8e42e6"
import script from "./TasksPage.vue?vue&type=script&lang=js"
export * from "./TasksPage.vue?vue&type=script&lang=js"

import "./TasksPage.vue?vue&type=style&index=0&id=9b8e42e6&lang=scss"

import exportComponent from "/home/docker/toodles/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__